import './Contactus.css'
import '../../App.css'
// import Header from '../../components/header/Header'
import Footer from '../../components/Footer/Footer'
import Menu from '../../components/menu/Menu'
import MobileMenu from '../../components/mobile_tabmennu/MobileMenu'
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { UseScrollToTop } from '../../components/scrollTop/ScrollTop';

const ContactUs=()=>{

    return(
        <div className='contact-main-container'>
            <UseScrollToTop/>
             {/* <div className="app-pc-menu top-bar">
                <Header/>
                </div> */}
                <div className='app-pc-menu'>
                <Menu page={'CONTACT'}/>
                </div>
                <div className='app-mobile-menu'>
                <MobileMenu/>
            </div>
        <div className='contact-detail-container'> 

        <div className='contact-input-left-container'>
                    <h2 className='contact-input-left-header'>Please get in touch and our expert support team will answer all your questions.</h2>
                    <p className='contact-input-left-detail-text'>We provide estimates by phone, email, or at your home. The estimate is completely free! Fill out the form, 
                        call us<span>+91 9986483320</span>or <span>marketing@kmpsdi.com</span>, and leave your telephone number and home address.
                    </p>
                    <div className='contact-input-left-icon-list'>
                        <div className='contact-input-left-icon'><FacebookIcon style={{fontSize:"1.5rem"}}/></div>
                        <div className='contact-input-left-icon'><XIcon style={{fontSize:"1.2rem"}}/></div>
                        <div className='contact-input-left-icon'><LinkedInIcon style={{fontSize:"1.5rem"}}/></div>
                        <div className='contact-input-left-icon'><YouTubeIcon style={{fontSize:"1.5rem"}}/></div>
                    </div>
                </div>

            <div className='contact-detail-items'>
                <h2 className='contact-detail-items-header'>INDIA</h2>
                <div className='contact-detail-items-text'>
                KMPS Digi Infra Private Limited, Ground floor, SMC House, 1/2, 6th Cross Rd, 6th main, 6th Block, HMT Layout, Vidyaranyapura, Bengaluru, Karnataka 560097.
                </div>
                <div style={{marginTop:"10px"}}>
                    <p className='contact-detail-items-number-mail'>9986483320</p>
                    <p className='contact-detail-items-number-mail'>marketing@kmpsdi.com</p>
                </div>
                
            </div>

            {/* <div className='contact-detail-items'>
                <h2 className='contact-detail-items-header'>USA Headquarter</h2>
                <div className='contact-detail-items-text'>
                304 NW St Homestead, Florida, Melrose Street, Water Mill,
                76B Overlook Drive Chester, PA 19013, Flemingsburg USA.
                </div>
                <div style={{marginTop:"10px"}}>
                    <p className='contact-detail-items-number-mail'>74182 41297</p>
                    <p className='contact-detail-items-number-mail'>info@firmcraft.in</p>
                </div>
                
            </div> */}

            {/* <div className='contact-detail-items'>
                <h2 className='contact-detail-items-header'>USA Headquarter</h2>
                <div className='contact-detail-items-text'>
                304 NW St Homestead, Florida, Melrose Street, Water Mill,
                76B Overlook Drive Chester, PA 19013, Flemingsburg USA.
                </div>
                <div style={{marginTop:"10px"}}>
                    <p className='contact-detail-items-number-mail'>74182 41297</p>
                    <p className='contact-detail-items-number-mail'>info@firmcraft.in</p>
                </div>
                
            </div> */}
        </div>
            <div style={{display:"none"}} className='service-header-details-container'>
                    <p className='service-header-text'>Get in Touch</p> 
                    <h2 className='service-header-text2'>Contact Us</h2> 
            </div>

            <div style={{display:"none"}} className='contact-input-container'>
                <div className='contact-input-left-container'>
                    <h2 className='contact-input-left-header'>Please get in touch and our expert support team will answer all your questions.</h2>
                    <p className='contact-input-left-detail-text'>We provide estimates by phone, email, or at your home. The estimate is completely free! Fill out the form, 
                        call us<span>+707 555-321</span>or <span>random@example.com</span>, and leave your telephone number and home address.
                    </p>
                    <div className='contact-input-left-icon-list'>
                        <div className='contact-input-left-icon'><FacebookIcon style={{fontSize:"1.5rem"}}/></div>
                        <div className='contact-input-left-icon'><XIcon style={{fontSize:"1.2rem"}}/></div>
                        <div className='contact-input-left-icon'><LinkedInIcon style={{fontSize:"1.5rem"}}/></div>
                        <div className='contact-input-left-icon'><YouTubeIcon style={{fontSize:"1.5rem"}}/></div>
                    </div>
                </div>
                <div className='contact-input-right-container' >
                    <div  className='contact-name-email-container'>
                        <input placeholder='Your Name'  className='contact-input-right-input'></input>
                        <input placeholder='Your Email' className='contact-input-right-input'></input>
                    </div>

                    <input placeholder='Your Phone'     className='contact-input-right-input'></input>
                   
                    <textarea placeholder='Message' className='contact-message-input'></textarea>

                </div>
            </div>
        <Footer/>
        </div>
    )
}

export default ContactUs;

